import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import BrandPage from './pages/BrandPage';
import BrandPagePreview from './pages/BrandPagePreview';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* A business's branded chat page: its own look, none of ours — no
            marketing header, footer or jawabai chat bubble. */}
        <Route path="/c/:slug" element={<BrandPage />} />
        {/* The dashboard editor's live preview of that page (iframe). */}
        <Route path="/c-preview" element={<BrandPagePreview />} />
        <Route path="*" element={<MarketingSite />} />
      </Routes>
    </BrowserRouter>
  );
}

function MarketingSite() {
  return (
    <div className="flex min-h-screen flex-col bg-bg text-text">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
